import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import i18n from '@/i18n';

export type SupportedLanguage = 'en' | 'tr' | 'ar';

interface LanguageState {
  currentLanguage: SupportedLanguage;
  isRTL: boolean;
  setLanguage: (language: SupportedLanguage) => void;
  getLanguageLabel: (language: SupportedLanguage) => string;
}

const languageLabels: Record<SupportedLanguage, string> = {
  en: 'English',
  tr: 'Türkçe',
  ar: 'العربية',
};

const rtlLanguages: SupportedLanguage[] = ['ar'];

export const useLanguageStore = create<LanguageState>()(
  persist(
    (set, get) => ({
      currentLanguage: 'en',
      isRTL: false,

      setLanguage: (language: SupportedLanguage) => {
        const isRTL = rtlLanguages.includes(language);
        
        // Update i18n language
        i18n.changeLanguage(language);
        
        // Update document direction and language
        document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
        document.documentElement.lang = language;
        
        set({
          currentLanguage: language,
          isRTL,
        });
      },

      getLanguageLabel: (language: SupportedLanguage) => {
        return languageLabels[language];
      },
    }),
    {
      name: 'letsparky-language',
      partialize: (state) => ({ currentLanguage: state.currentLanguage }),
      onRehydrateStorage: () => (state) => {
        if (state) {
          // Apply language settings on app load
          state.setLanguage(state.currentLanguage);
        }
      },
    }
  )
); 